module.exports = __webpack_public_path__ + "static/img/product_11.6a5b9f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_11.jpg
// module id = nmEE
// module chunks = 2